// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import bookOpen01Icon from "@/assets/icons/book-open-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BookOpen01IconProps = Omit<IconProps, "name">;

export function BookOpen01Icon(props: BookOpen01IconProps): React.ReactNode {
  return <Icon name={bookOpen01Icon} {...props} />;
}
